import cookieDeclaration from './snippets/cookie-declaration';
import cookieNotificationHr from './snippets/cookie-privacy-notification-hr';
import footerKontakt from './snippets/footer-kontakt';
import footerNaciniPlacanja from './snippets/footer-nacini-placanja';
import footerSocialNetworks from './snippets/footer-social-networks';
import helpCenter from './snippets/help-center-hr';
import promotionLinkHr from './snippets/promotion-link-hr';
import registerBanner from './snippets/register-banner-hr';
import registerSuccessHr from './snippets/register-success-hr';
import responsibleGamingHr from './snippets/responsible-gaming-hr';

export const FALLBACK_SNIPPETS = {
  'cookie-privacy-notification': {
    hr: cookieNotificationHr
  },
  'promotion-link': {
    hr: promotionLinkHr
  },
  'register-success': {
    hr: registerSuccessHr
  },
  'register-banner': {
    hr: registerBanner
  },
  'help-center': {
    hr: helpCenter
  },
  'footer-kontakt': {
    hr: footerKontakt
  },
  'footer-social-networks': {
    hr: footerSocialNetworks
  },
  'footer.nacini-placanja': {
    hr: footerNaciniPlacanja
  },
  'responsible-gaming': {
    hr: responsibleGamingHr
  },
  'cookie-declaration': {
    hr: cookieDeclaration
  }
};
